/**
 * Created by zuozhuo on 2018/1/25.
 */
/* eslint-disable import/no-webpack-loader-syntax */

import React from "react";
import ReactRouterUrl from "./ReactRouterUrl";
import { createLazy } from "./LazyComponent";
import { Redirect } from "react-router-dom";

import keepComponent from "../utils/router-keep-component";

import PageDemoListView from "bundle-loader?lazy!../pages/demo/DemoListView";
import PageMenuIndex from "bundle-loader?lazy!../pages/demo/MenuIndex";
import PageDemoBridgeTest from "bundle-loader?lazy!../pages/demo/PageDemoBridgeTest";
import PageDebugSettings from "bundle-loader?lazy!../pages/demo/PageDebugSettings";
import PageDemoMLinksTest from "bundle-loader?lazy!../pages/demo/PageDemoMLinksTest";

import PageArticleList from "bundle-loader?lazy!../pages/article/PageArticleList";
import PageArticleDetail from "bundle-loader?lazy!../pages/article/PageArticleDetail";
import PageArticleCategory from "bundle-loader?lazy!../pages/article/PageArticleCategory";

import PageLogin from "bundle-loader?lazy!../pages/login/PageLogin";
import PageBindPhone from "bundle-loader?lazy!../pages/login/PageBindPhone";
import PagePerfectInfo from "bundle-loader?lazy!../pages/login/PagePerfectInfo";
import PageBindOrg from "bundle-loader?lazy!../pages/evaluation/PageBindOrg";
import PageStudentLogin from "bundle-loader?lazy!../pages/evaluation/PageStudentLogin";
import PageCreateConsultOrder from "bundle-loader?lazy!../pages/evaluation/PageCreateConsultOrder";
import PagePasswordLogin from "bundle-loader?lazy!../pages/login/PagePasswordLogin";
import Page404 from "bundle-loader?lazy!../pages/Page404";

import PageRiskDiagnosis from "bundle-loader?lazy!../pages/risk_diagnosis/PageRiskDiagnosis";
import PageRiskDiagnosisList from "bundle-loader?lazy!../pages/risk_diagnosis/PageRiskDiagnosisList";
import PageRiskDiagnosisCreate from "bundle-loader?lazy!../pages/risk_diagnosis/PageRiskDiagnosisCreate";
import PageRiskDiagnosisDetail from "bundle-loader?lazy!../pages/risk_diagnosis/PageRiskDiagnosisDetail";

import PageMine from "bundle-loader?lazy!../pages/mine/PageMine";
import PageCompleteMyInfo from "bundle-loader?lazy!../pages/mine/PageCompleteMyInfo";
import PageRecharge from "bundle-loader?lazy!../pages/mine/PageRecharge";
import PageMyPoints from "bundle-loader?lazy!../pages/mine/PageMyPoints";
import PagePurchaseList from "bundle-loader?lazy!../pages/mine/PagePurchaseList";
import PageRanking from "bundle-loader?lazy!../pages/mine/PageRanking";
import PageHelpCenter from "bundle-loader?lazy!../pages/mine/PageHelpCenter";
import PageHelpCenterDetail from "bundle-loader?lazy!../pages/mine/PageHelpCenterDetail";
import PagePostDetail from "bundle-loader?lazy!../pages/mine/PagePostDetail";
import PagePointExchange from "bundle-loader?lazy!../pages/mine/PagePointExchange";
import PageWelfareList from "bundle-loader?lazy!../pages/mine/PageWelfareList";
import PageOfflinePointsGet from "bundle-loader?lazy!../pages/mine/PageOfflinePointsGet";
import PageAppointment from "bundle-loader?lazy!../pages/mine/PageAppointment";
import PageAppointmentDetail from "bundle-loader?lazy!../pages/mine/PageAppointmentDetail";

import PageLessonList from "bundle-loader?lazy!../pages/lesson/PageLessonList";
import PageMyLesson from "bundle-loader?lazy!../pages/mine/PageMyLesson";
import PageLessonDetail from "bundle-loader?lazy!../pages/lesson/PageLessonDetail";
import PageLearn from "bundle-loader?lazy!../pages/lesson/PageLessonLearn";
import PageLessonExam from "bundle-loader?lazy!../pages/lesson/PageLessonExam";
import PageLessonExamResult from "bundle-loader?lazy!../pages/lesson/PageLessonExamResult";

import PageColumnList from "bundle-loader?lazy!../pages/column/PageColumnList";
import PageColumnDetail from "bundle-loader?lazy!../pages/column/PageColumnDetail";
import PageColumnArticleShare from "bundle-loader?lazy!../pages/column/PageColumnArticleShare";
import PageColumnArticleList from "bundle-loader?lazy!../pages/column/PageColumnArticleList";
import PageColumnLearn from "bundle-loader?lazy!../pages/column/PageColumnLearn";

import PageHome from "bundle-loader?lazy!../pages/PageHome/index";
import PageHtmlIFrame from "bundle-loader?lazy!../pages/PageHtmlIFrame";

import PageZFB from "bundle-loader?lazy!../pages/AppH5/PageZFB/index";
import PageWeChat from "bundle-loader?lazy!../pages/AppH5/PageWeChat/index";

import PageLive from "bundle-loader?lazy!../pages/live/PageLive/index";
import PageLiveDetail from "bundle-loader?lazy!../pages/live/PageLiveDetail/index";

import PageAngelList from "bundle-loader?lazy!../pages/angel/PageAngelList";
import PageAngelCustom from "bundle-loader?lazy!../pages/angel/PageAngelCustom";
import PageAngelReceive from "bundle-loader?lazy!../pages/angel/PageAngelReceive";
import PageAngelInvitation from "bundle-loader?lazy!../pages/angel/PageAngelInvitation";
import PageAngelInvalid from "bundle-loader?lazy!../pages/angel/PageAngelInvalid";

import PageCommentDetail from "bundle-loader?lazy!../pages/comment/PageCommentDetail";
import PageCommentList from "bundle-loader?lazy!../pages/comment/PageCommentList";

import PageQAList from "bundle-loader?lazy!../pages/PageQA/PageQAList";
import PageQADetail from "bundle-loader?lazy!../pages/PageQA/PageQADetail";
import PageQARefundDetail from "bundle-loader?lazy!../pages/PageQA/PageQARefundDetail";
import PageExpertList from "bundle-loader?lazy!../pages/PageQA/PageExpertList";
import PageExpertDetail from "bundle-loader?lazy!../pages/PageQA/PageExpertDetail";
import PageQAQuestion from "bundle-loader?lazy!../pages/PageQA/PageQAQuestion";
import PageQACommentDetail from "bundle-loader?lazy!../pages/PageQA/PageQACommentDetail";

import PageMallGoods from "bundle-loader?lazy!../pages/mall/PageMallGoods";
import PageMallOrderList from "bundle-loader?lazy!../pages/mall/PageMallOrderList";
import PageMallOrderDetail from "bundle-loader?lazy!../pages/mall/PageMallOrderDetail";
import PageMallShoppingCart from "bundle-loader?lazy!../pages/mall/PageMallShoppingCart";
import PageMallGoodsList from "bundle-loader?lazy!../pages/mall/PageMallGoodsList";
import PageMallOrderConfirm from "bundle-loader?lazy!../pages/mall/PageMallOrderConfirm";
import PageMallGoodsDetail from "bundle-loader?lazy!../pages/mall/PageMallGoodsDetail";

import PagePaymentSuccess from "bundle-loader?lazy!../pages/payment_success/PagePaymentSuccess";

import PageDrawRedPacket from "bundle-loader?lazy!../pages/red_packet/PageDrawRedPacket";

import PageCardActivate from "bundle-loader?lazy!../pages/card/PageCardActivate";

import PageVodDetail from "bundle-loader?lazy!../pages/vod/PageVodDetail";

import PageQrcodePurchase from "bundle-loader?lazy!../pages/qrcode_purchase/PageQrcodePurchase";

import PageEvaluationHome from "bundle-loader?lazy!../pages/evaluation/PageEvaluationHome";
import PageEvaluationMine from "bundle-loader?lazy!../pages/evaluation/PageEvaluationMine";

import PageEvaluationSearch from "bundle-loader?lazy!../pages/evaluation/PageSearch";
import PageEvaluationReady from "bundle-loader?lazy!../pages/evaluation/PageEvaluationReady";

import PageEvaluationResult from "bundle-loader?lazy!../pages/evaluation/PageEvaluationResult";

import PageEvaluationStart from "bundle-loader?lazy!../pages/evaluation/PageEvaluationStart";

import PageActivityLottery from "bundle-loader?lazy!../pages/activity/PageActivityLottery";

import PagePayRedPacket from "bundle-loader?lazy!../pages/mine/PagePayRedPacket";

import PageCounselor from "bundle-loader?lazy!../pages/counselor/PageCounselor/index";
import PageCounselorDetail from "bundle-loader?lazy!../pages/counselor/PageCounselorDetail/index";
import PageCounselorAppointment from "bundle-loader?lazy!../pages/counselor/PageCounselorAppointment/index";
import PageCounselorAppointmentDetail from "bundle-loader?lazy!../pages/counselor/PageCounselorAppointmentDetail/index";
import PageCounselorAppeal from "bundle-loader?lazy!../pages/counselor/PageCounselorAppeal/index";
import PageCounselorComments from "bundle-loader?lazy!../pages/counselor/PageCounselorComments/index";

import PageTestWxSdk from "bundle-loader?lazy!../pages/Test/WxSdk";

import PageDownloadApp from "bundle-loader?lazy!../pages/download-app";

import { FRONT_PREFIX, WEIXIN_PAY_PAGES_TYPE } from "../consts/consts";
import RedirectForPayment from "../components/RedirectForPayment";
import utils from "../utils/utils";

/*h5读书会*/
import PageReadMeeting from "bundle-loader?lazy!../pages/read_meeting";

export const urlPageHtmlIFrame = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/html_iframe",
  component: createLazy(PageHtmlIFrame)
});

export const urlPageMenuIndex = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/demo",
  component: createLazy(PageMenuIndex)
});

export const urlPageDemoListView = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/demo/list-view",
  component: createLazy(PageDemoListView)
});

export const urlPageDemoBridgeTest = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/demo/bridge",
  component: createLazy(PageDemoBridgeTest)
});

export const urlPageDebugSettings = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/demo/debug_settings",
  component: createLazy(PageDebugSettings)
});

export const urlPageDemoMLinksTest = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/demo/mlinks_test",
  component: createLazy(PageDemoMLinksTest)
});

/*
微信绑定手机登录页\H5活动引导新用户注册页
 */
export const urlPageLogin = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/login",
  component: createLazy(PageLogin)
});
export const urlPageBindPhone = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/login/bind_phone",
  component: createLazy(PageBindPhone)
});
export const urlPagePerfectInfo = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/login/perfect_info",
  component: createLazy(PagePerfectInfo)
});
export const urlPageBindOrg = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/bind_org",
  component: createLazy(PageBindOrg)
});
export const urlPageStudentLogin = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/student_login",
  component: createLazy(PageStudentLogin)
});
export const urlPageCreateConsultOrder = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/create_consult_order",
  component: createLazy(PageCreateConsultOrder)
});
export const urlPagePasswordLogin = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/login/password",
  component: createLazy(PagePasswordLogin)
});
// Page404
export const urlPage404 = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/404",
  component: createLazy(Page404)
});

export const urlPageRiskDiagnosis = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/risk_diagnosis",
  component: createLazy(PageRiskDiagnosis)
});

export const urlPageRiskDiagnosisList = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/risk_diagnosis/list",
  component: createLazy(PageRiskDiagnosisList)
});

export const urlPageRiskDiagnosisCreate = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/risk_diagnosis/create",
  component: createLazy(PageRiskDiagnosisCreate)
});

export const urlPageRiskDiagnosisDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/risk_diagnosis/:id",
  component: createLazy(PageRiskDiagnosisDetail)
});

export const urlPageMine = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mine",
  component: createLazy(PageMine)
});

export const urlPageCompleteMyInfo = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/complete_my_info",
  component: createLazy(PageCompleteMyInfo)
});

export const urlPageWelfareList = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/welfare_list",
  component: createLazy(PageWelfareList)
});

export const urlPageOfflinePointsGet = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/offline_points_get",
  component: createLazy(PageOfflinePointsGet)
});

export const urlPagePointExchange = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/point_exchange",
  component: createLazy(PagePointExchange)
});

export const urlPageRecharge = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/recharge",
  // /front/wx_pay/?weixinPayPageType=recharge
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{}}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.recharge}
    />
  )
});

export const urlPageMyPoints = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/points",
  component: createLazy(PageMyPoints)
});

export const urlPageHelpCenter = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mine/help",
  component: createLazy(PageHelpCenter)
});

export const urlPageHelpCenterDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mine/help/detail",
  component: createLazy(PageHelpCenterDetail)
});

export const urlPagePurchaseList = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/purchase_list",
  component: createLazy(PagePurchaseList)
});

export const urlPageAppointment = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/appointment",
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{}}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.mineAppointment}
    />
  )
});

export const urlPageAppointmentDetail = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mine/appointment/:id",
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.mineAppointmentDetail}
    />
  )
});

// 话题帖子学习小组详情
export const urlPagePostDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/post/:id",
  component: createLazy(PagePostDetail)
});

export const urlPageRanking = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/ranking",
  component: createLazy(PageRanking)
});

export const urlPageHome = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/home",
  component: createLazy(PageHome)
});

export const urlPageLive = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/live",
  component: createLazy(PageLive)
});

export const urlPageLiveDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/live/detail/:id",
  // /front/wx_pay/?id=:id&weixinPayPageType=liveDetail
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.liveDetail}
    />
  )
});
// TODO 回播

/*法商天使*/
export const urlPageAngelList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/angel",
  component: createLazy(PageAngelList)
});

export const urlPageAngelCustom = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/angel/custom",
  component: createLazy(PageAngelCustom)
});

export const urlPageAngelReceive = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/angel/receive",
  component: createLazy(PageAngelReceive)
});

export const urlPageAngelInvitation = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/angel/invitation",
  component: createLazy(PageAngelInvitation)
});

export const urlPageAngelInvalid = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/angel/invalid",
  component: createLazy(PageAngelInvalid)
});

/*问答*/
export const urlPageQAQuestion = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/qa/question",
  component: props => (
    <RedirectForPayment
      {...props}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.qaQuestion}
    />
  )
});
export const urlPageQAList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa",
  component: props => (
    <RedirectForPayment
      {...props}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.qaList}
    />
  )
});

export const urlPageExpertList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa/expert",
  component: createLazy(PageExpertList)
});

export const urlPageQADetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa/:id",
  // /front/wx_pay/?id=:id&weixinPayPageType=qa
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.qa}
    />
  )
});

export const urlPageQARefundDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa/refund/:id",
  component: createLazy(PageQARefundDetail)
});
export const urlPageQACommentDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa/:qa_id/comment/:id",
  component: props => (
    <RedirectForPayment
      {...props}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.qaQuestionDetail}
      paramsToQuery={{ qa_id: "qa_id", id: "id" }}
    />
  )
});

export const urlPageExpertDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/qa/expert/:id",
  component: createLazy(PageExpertDetail)
});

/*商城*/
export const urlPageMall = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall",
  component: createLazy(PageMallGoods)
});
export const urlPageMallGoods = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall/goods",
  component: createLazy(PageMallGoods)
});
export const urlPageMallGoodsDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall/goods/:id",
  component: createLazy(PageMallGoodsDetail)
});
export const urlPageMallGoodsList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall/goods/goods/list/:id",
  component: createLazy(PageMallGoodsList)
});
export const urlPageMallOrderList = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mall/order/list",
  // /front/wx_pay/?weixinPayPageType=orderList
  component: props => (
    <RedirectForPayment
      {...props}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.orderList}
    />
  )
});
export const urlPageMallOrderDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall/order/detail/:id",
  // /front/wx_pay/?id=:id&weixinPayPageType=order
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.order}
    />
  )
});
export const urlPageMallShoppingCart = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/mall/shopping-cart",
  component: createLazy(PageMallShoppingCart)
});
export const urlPageMallOrderConfirm = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/mall/order-confirm",
  // /front/wx_pay/?weixinPayPageType=mall
  component: props => (
    <RedirectForPayment
      {...props}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.mall}
    />
  )
});

/*课程*/
export const urlPageLessonList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/lesson_list",
  component: createLazy(PageLessonList)
});
export const urlPageLessonDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/lesson/:id",
  // /front/wx_pay/?id=:id&weixinPayPageType=lesson
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.lesson}
    />
  )
});
export const urlPageLearn = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/lesson/:lesson_id/learn/:id",
  component: createLazy(PageLearn)
});
export const urlPageLessonExam = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/lesson/:lesson_id/learn/:id/exam",
  component: createLazy(PageLessonExam)
});
export const urlPageLessonExamResult = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/lesson/:lesson_id/learn/:id/exam_result",
  component: createLazy(PageLessonExamResult)
});

export const urlPageMyLesson = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/my_lesson",
  component: createLazy(PageMyLesson)
});

/*文章*/
export const urlPageArticleList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/articles",
  component: createLazy(PageArticleList)
});
export const urlPageArticleDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/article/:id",
  component: createLazy(PageArticleDetail)
});
export const urlPageArticleCategory = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/articles/category/:id",
  component: createLazy(PageArticleCategory)
});

/*订阅*/
export const urlPageColumnList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/columns",
  component: createLazy(PageColumnList)
});
export const urlPageCommonWeixinPay = new ReactRouterUrl({
  exact: true,
  path: `${FRONT_PREFIX}/wx_pay/`,
  component: props => {
    let { weixinPayPageType } = utils.getUrlQuery();
    weixinPayPageType = weixinPayPageType.replace(/null/g, "");
    let DynamicPage = createLazy(Page404);
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.columnDetail) {
      DynamicPage = createLazy(PageColumnDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.recharge) {
      DynamicPage = createLazy(PageRecharge);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.mall) {
      DynamicPage = createLazy(PageMallOrderConfirm);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.order) {
      DynamicPage = createLazy(PageMallOrderDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.orderList) {
      DynamicPage = createLazy(PageMallOrderList);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.lesson) {
      DynamicPage = createLazy(PageLessonDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.qa) {
      DynamicPage = createLazy(PageQADetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.qaList) {
      DynamicPage = createLazy(PageQAList);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.liveDetail) {
      DynamicPage = createLazy(PageLiveDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.qaQuestion) {
      DynamicPage = createLazy(PageQAQuestion);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.qaQuestionDetail) {
      DynamicPage = createLazy(PageQACommentDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.appointment) {
      DynamicPage = createLazy(PageCounselorAppointment);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.mineAppointment) {
      DynamicPage = createLazy(PageAppointment);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.mineAppointmentDetail) {
      DynamicPage = createLazy(PageAppointmentDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.vodDetail) {
      DynamicPage = createLazy(PageVodDetail);
    }
    if (weixinPayPageType === WEIXIN_PAY_PAGES_TYPE.evaluation) {
      DynamicPage = createLazy(PageEvaluationHome);
    }
    return <DynamicPage {...props} />;
  }
});
export const urlPageColumnDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/column/:id",
  // /front/wx_pay/?id=:id&weixinPayPageType=columnDetail
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.columnDetail}
    />
  )
});
export const urlPageColumnLearn = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/column/learn/:id",
  component: createLazy(PageColumnLearn)
});
export const urlPageColumnArticleShare = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/column/article/:id/share",
  component: createLazy(PageColumnArticleShare)
});
export const urlPageColumnArticleList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/column/:id/article_list",
  component: createLazy(PageColumnArticleList)
});

/*评论*/
export const urlPageCommentDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/comments/:id",
  component: createLazy(PageCommentDetail)
});
export const urlPageCommentList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/comments-list",
  component: createLazy(PageCommentList)
});

/// 我的红包列表 type:none, sub, class
/// 价格
export const urlPagePayRedPacketList = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/my-redpacket-list",
  component: createLazy(PagePayRedPacket)
});

/*红包*/
export const urlPageDrawRedPacket = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/draw-red-packet/:id",
  component: createLazy(PageDrawRedPacket)
});

/*H5页面,引导设置appstore支付*/
export const urlPageZFB = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/appstore/zfb",
  component: createLazy(PageZFB)
});
export const urlPageWeChat = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/appstore/wechat",
  component: createLazy(PageWeChat)
});
export const urlPageUnionPay = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/appstore/unionpay",
  component: () => (
    <Redirect
      push={false}
      to={urlPageHtmlIFrame.formatUrl(
        {},
        { src: "/front-static/html/recharge_guide/unionpay/index.html" }
      )}
    />
  )
});

/*卡激活*/
export const urlPageCardActivate = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/card-activate",
  component: createLazy(PageCardActivate)
});

/*支付成功*/
export const urlPagePaymentSuccess = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/payment-success",
  component: createLazy(PagePaymentSuccess)
});

/* 点播 */
export const urlPageVodDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/vod/detail/:id",
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.vodDetail}
    />
  )
});

/* 扫码购买课程 */
export const urlPageQrcodePurchase = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/qrcode-purchase",
  component: createLazy(PageQrcodePurchase)
});

/* 测评 */
export const urlPageEvaluation = new ReactRouterUrl({
  exact: true,
  // ?company_id=单位ID&dept_id=部门ID&eval_id=项目ID
  path: FRONT_PREFIX + "/evaluation",
  // component: props => (
  //   <RedirectForPayment
  //     {...props}
  //     paramsToQuery={{ id: "id" }}
  //     weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.evaluation}
  //   />
  // )
  component: createLazy(PageEvaluationHome)
});

/* 我的测评 */
export const urlPageEvaluationMine = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  path: FRONT_PREFIX + "/evaluation-mine",
  component: createLazy(PageEvaluationMine)
});

/* 测评搜索 */
export const urlPageEvaluationSearch = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/evaluation/search",
  component: createLazy(PageEvaluationSearch)
});

/* 准备测评 */
export const urlPageEvaluationReady = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  // id:测评项目ID,?mde_id=测评任务ID
  path: FRONT_PREFIX + "/evaluation/ready/:id",
  component: createLazy(PageEvaluationReady)
});

/* 开始测评 */
export const urlPageEvaluationStart = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  // id:测评项目ID,?mde_id=测评任务ID
  path: FRONT_PREFIX + "/evaluation/start/:id",
  component: createLazy(PageEvaluationStart)
});

/* 测评结果 */
export const urlPageEvaluationResult = new ReactRouterUrl({
  exact: true,
  loginRequired: true,
  // id:测评结果ID,?mde_id=测评任务ID
  path: FRONT_PREFIX + "/evaluation/result/:id",
  component: createLazy(PageEvaluationResult)
});

/* 活动 */
export const urlPageActivityLottery = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/activity/lottery618",
  component: createLazy(PageActivityLottery)
});

/* 咨询师列表 */
export const urlPageCounselor = new ReactRouterUrl({
  // exact: true,
  path: FRONT_PREFIX + "/counselor",
  component: keepComponent({
    component: createLazy(PageCounselor),
    children: [
      {
        path: ":id",
        component: createLazy(PageCounselorDetail)
      }
    ]
  })
});

/* 咨询师详情 */
export const urlPageCounselorDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/counselor/:id",
  component: (
    <div>注意这条路由放在urlPageCounselor下面，会被忽略，这是可以的</div>
  ) // createLazy(PageCounselorDetail)
});

/* 咨询预约详情 */
export const urlPageCounselorAppointmentDetail = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/counselor-appointment/:id",
  component: createLazy(PageCounselorAppointmentDetail)
});

/* 申诉 */
export const urlPageCounselorAppeal = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/counselor-appeal/:id",
  component: createLazy(PageCounselorAppeal)
});

/* 咨询师预约 */
export const urlPageCounselorAppointment = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/counselor/:id/appointment",
  loginRequired: true,
  component: props => (
    <RedirectForPayment
      {...props}
      paramsToQuery={{ id: "id" }}
      weixinPayPageType={WEIXIN_PAY_PAGES_TYPE.appointment}
    />
  )
});

/* 咨询师评价 */
export const urlPageCounselorComments = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/counselor/:id/comments",
  component: createLazy(PageCounselorComments)
});

/*------------------读书会h5--------------------*/
export const urlPageReadMeeting = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/read_meeting/:id",
  component: createLazy(PageReadMeeting)
});

/* Test WxSdk */
export const urlPageTestWxSdk = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/test/wx-sdk",
  component: createLazy(PageTestWxSdk)
});

/* app下载 */
export const urlPageDownloadApp = new ReactRouterUrl({
  exact: true,
  path: FRONT_PREFIX + "/download-app",
  component: createLazy(PageDownloadApp)
});



// WEBPACK FOOTER //
// ./src/router/allUrls.js